import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryActive, white } from '../../../styles/colors';
import { shadows, transitions } from '../styles/baseStyles';
import { PHANTOM_EDGE } from '../utils/layoutConstants';

export const styleSheet = StyleSheet.create({
	buttonContainer: {
		position: 'absolute',
		pointerEvents: 'all',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 8,
	},
	addButton: {
		width: PHANTOM_EDGE.BUTTON_SIZE,
		height: PHANTOM_EDGE.BUTTON_SIZE,
		borderRadius: '50%',
		backgroundColor: brandPrimary,
		color: white,
		border: `3px solid ${white}`,
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		boxShadow: shadows.cardHover,
		transition: transitions.all,
		':hover': {
			backgroundColor: brandPrimaryActive,
			transform: 'scale(1.1)',
			boxShadow: '0 6px 20px rgba(4, 102, 255, 0.4)',
		},
		':active': {
			transform: 'scale(0.95)',
		},
		':disabled': {
			opacity: 0.6,
			cursor: 'not-allowed',
			transform: 'none',
		},
		':focus': {
			outline: '3px solid rgba(4, 102, 255, 0.4)',
			outlineOffset: 2,
		},
	},
	addButtonLoading: {
		pointerEvents: 'none' as const,
	},
	spinner: {
		width: 24,
		height: 24,
		animationName: {
			from: { transform: 'rotate(0deg)' },
			to: { transform: 'rotate(360deg)' },
		},
		animationDuration: '1s',
		animationIterationCount: 'infinite',
		animationTimingFunction: 'linear',
	},
});
